import { ProfileInterface } from "@/modules/authentication/types";
import { RoleInterface } from "@/modules/roles/types";
import { VacationInterface } from "@/modules/transactions/types";
import axios from "@/network";
import { AxiosResponse } from "axios";

export function apiGetUsers(params: any, headers = {}): any {
  const url = "/users";
  return axios.get(url, { params, headers });
}

export function apiGetUser(userId: number): any {
  const url = `/users/${userId}`;
  return axios.get(url);
}

export function apiUpdateUser(userId: number, updatedUser: ProfileInterface): any {
  const url = `/users/${userId}`;
  const payload = { user: updatedUser };
  return axios.patch(url, payload);
}

export function apiGetBirthdays(): any {
  return axios.get(`/users/birthdays`);
}

export function apiCreateUser(newUser: any): any {
  const url = "/users";
  const payload = { user: newUser };
  return axios.post(url, payload);
}

export function apiStoreExperience(type: any, userId: number, newExperience: any): any {
  let payload = null;
  switch (type) {
    case "educations":
      payload = { education: newExperience };
      break;
    case "knowledge_domains":
      payload = { knowledge_domain_user: newExperience };
      break;
    case "merits":
      payload = { merit: newExperience };
      break;
    case "work_experiences":
      payload = { work_experience: newExperience };
      break;
    default:
      throw `Could not store the experience because of unknown type '${type}'`;
  }
  const url = `/users/${userId}/${type}`;
  return axios.post(url, payload);
}

export function apiUpdateExperience(
  type: any,
  userId: number,
  experienceId: number,
  updatedExperience: any
): any {
  let payload = null;
  switch (type) {
    case "educations":
      payload = { education: updatedExperience };
      break;
    case "knowledge_domains":
      payload = { knowledge_domain_user: updatedExperience };
      break;
    case "merits":
      payload = { merit: updatedExperience };
      break;
    case "work_experiences":
      payload = { work_experience: updatedExperience };
      break;
    default:
      throw `Could not update the experience because of unknown type '${type}'`;
  }
  const url = `/users/${userId}/${type}/${experienceId}`;
  return axios.patch(url, payload);
}

export function apiDestroyExperience(type: any, userId: number, experienceId: any): any {
  const url = `/users/${userId}/${type}/${experienceId}`;
  return axios.delete(url);
}

export function apiGetInterests(): any {
  const url = "/interests";
  return axios.get(url);
}

export function apiUpdateUserInterests(userId: number, updatedInterests: Array<any>): any {
  const url = `/users/${userId}/interests`;
  const payload = { interests: updatedInterests };
  return axios.patch(url, payload);
}

export function apiGetUserPermissions(): any {
  const url = "/user_roles";
  return axios.get(url);
}

export function apiGetUserRoles(userId: number, params?: any): any {
  const url = `/users/${userId}/roles`;
  return axios.get(url, { params });
}

export function apiGetUserRole(userId: number, roleId: number, params?: any): any {
  const url = `/users/${userId}/roles/${roleId}`;
  return axios.get(url, { params });
}

export function apiUpdateUserRole(
  projectId: number,
  roleId: number,
  updatedRole: RoleInterface
): any {
  const url = `/projects/${projectId}/roles/${roleId}`;
  const payload = { role: updatedRole };
  return axios.patch(url, payload);
}

export function apiDestroyUserRole(projectId: number, roleId: number): any {
  const url = `/projects/${projectId}/roles/${roleId}`;
  return axios.delete(url);
}

export function apiUpdateUserReceipt(updatedReceipt: any): any {
  const url = `users/${updatedReceipt.user.id}/receipts/${updatedReceipt.id}`;
  const payload = { receipt: updatedReceipt };
  return axios.patch(url, payload);
}

export function apiGetVacationSummary(user_id: number) {
  const url = `/users/${user_id}/vacation_summary`;
  return axios.get(url);
}

export async function apiGetUserVacationYears(
  user_id: number
): Promise<AxiosResponse<{ data: Array<VacationInterface> }>> {
  const url = `/users/${user_id}/vacation_years`;
  return await axios.get(url);
}

export async function apiGetUserVacationYear(
  user_id: number,
  year: number
): Promise<AxiosResponse<{ data: VacationInterface }>> {
  const url = `/users/${user_id}/vacation_years/${year}`;
  return await axios.get(url);
}

export function apiUpdateUserSavedVacationDays(user_id: number, year: number, days: number): any {
  const url = `/users/${user_id}/vacation_years/${year}`;
  const payload = { vacation_year: { vacation_days_saved: days } };
  return axios.patch(url, payload);
}

export function apiGetLockSummary(user_id: number, start_date: string, end_date: string) {
  const url = `/users/${user_id}/lock_summary`;
  const params = { start_date: start_date, end_date: end_date };
  return axios.get(url, { params });
}

export function apiGetReports(params = {}, headers = {}) {
  const url = "/reports";
  return axios.get(url, { params, headers });
}
